import axios from "axios";
import { Mixpanel } from "../utils/Mixpanel";

// Use this API when you are not authenticated and you wish to login/register
const loginApi = axios.create({
    baseURL: `${process.env.REACT_APP_API_AUTH_HOST}/api/v1`,
    withCredentials: true,
    headers: {
        "Content-type": "application/json",
    },
});

loginApi.interceptors.response.use(
    (res) => {
        return res;
    },
    async (err) => {
        const originalConfig = err.config;
        if (!err.response) {
            Mixpanel.track("UI IDP API Unresponsive - network error to /" + originalConfig.url);
        }
        return Promise.reject(err);
    }
);
export default loginApi;
